import React from "react";
import { WithPopup, Popup, Icon } from "@abb/abb-common-ux-react";
import styled, { useTheme } from "styled-components";

const Container = styled.div`
  position: absolute;
  width: ${props => props.theme.sizes.m};
  height: ${props => props.theme.sizes.m};
  top: 39px;
  left: 108px;
`;

export const SearchFormInfo: React.FunctionComponent = (props) => {
  const theme = useTheme();

  return (
    <Container>
      <WithPopup>
        <div
          style={{
            width: theme.sizes.m,
            height: theme.sizes.m,
            marginTop: "0",
            alignSelf: "center"
          }}
        >
          <Icon name="abb/information-circle-1" />
        </div>
        <Popup trigger="hover">{props.children}</Popup>
      </WithPopup>
    </Container>
  );
};
